export const dataLibV = [{
  word: 'vè',
  partOfSpeech: 'N',
  definition: ['worm'],
  egSentenceKw: 'Vyann-an gaté; i benyen vè.',
  egSentenceEn: 'The meat is spoiled; it is full of worms.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. ver]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'vè',
  partOfSpeech: 'ADJ',
  definition: ['green'],
  egSentenceKw: 'Nou kontan kay vè-a.',
  egSentenceEn: 'We like the green house.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. vert]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'vlé',
  partOfSpeech: 'V',
  definition: ['to want'],
  egSentenceKw: 'Mwen vlé tak kafé, souplé.',
  egSentenceEn: 'I want some coffee, please.',
  synonym: ['anvi'],
  antonym: [null],
  etymology: '[< Fr. voulez]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'vann',
  partOfSpeech: 'N',
  definition: ['van'],
  egSentenceKw: 'Yo kay wanjé vann-an.',
  egSentenceEn: 'They\'ll repair the van.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. van]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'vann',
  partOfSpeech: 'V',
  definition: ['to sell'],
  egSentenceKw: 'Konmen ou ka vann sé bwapen-an?',
  egSentenceEn: 'How much are you selling the breadfruit for?',
  synonym: [null],
  antonym: ['achté'],
  etymology: '[< Fr. vendre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'vann',
  partOfSpeech: 'V',
  definition: ['to lose a game deliberately'],
  egSentenceKw: 'Yo péyé kaptenn-an pou vann jwé-a.',
  egSentenceEn: 'They paid the captain to lose the game deliberately.',
  synonym: [null],
  antonym: ['achté'],
  etymology: '[< Fr. vendre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'vini',
  partOfSpeech: 'V',
  definition: ['to come'],
  egSentenceKw: 'Papa mwen kay vini denmen.',
  egSentenceEn: 'My father will come tomorrow.',
  synonym: ['chapé'],
  antonym: ['alé'],
  etymology: '[< Fr. venir]',
  dialect: '🇱🇨',
  variant: ['vin'],
}, {
  word: 'vizavi',
  partOfSpeech: 'PREP',
  definition: ['in line with', 'with respect to'],
  egSentenceKw: 'Lè ou wivé vizavi kay-la, gadé dwèt; ou kay wè motoka-a.',
  egSentenceEn: 'When you get in line with the house, look straight; you will see my car.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. vis à vis]',
  dialect: '🇱🇨',
  variant: [null],
},
];
